import { createBrowserHistory } from 'history';

export const bpHistory = createBrowserHistory();
